module.exports = __webpack_public_path__ + "img/nt56-01-80-1.prt.088da820.jpg";